import script from "./AdminAnalyze.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnalyze.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnalyze.vue?vue&type=style&index=0&id=5192bfde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5192bfde"]])

export default __exports__